import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-account-recovery-request-url-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './account-recovery-request-url.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class AccountRecoveryRequestUrlTemplateComponent {
  public static ngAcceptInputType_data: WrappedValue<AccountRecoveryRequestUrlTemplateData>;

  @Input({ required: true })
  public data: WrappedValue<AccountRecoveryRequestUrlTemplateData>;
}

export type AccountRecoveryRequestUrlTemplateData = {
  title: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  p1: string;
  recovery_url: string;
  recovery_url_label: string;
  p2: string;
  p3_html: string;
};

export const AccountRecoveryRequestUrlTemplateMocks: AccountRecoveryRequestUrlTemplateData[] = [
  {
    title: 'Account recovery',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
    p1: 'Great! You have regained access to your Recruitee account.',
    recovery_url: 'www.google.pl',
    recovery_url_label: 'Regain access now',
    p2: 'Please note that once you log in, the 2FA feature will be disabled. You can set it up again in settings.',
    p3_html:
      "On %{date} we've received a request to recover access to your account after losing a two-factor authentication device. If it wasn't you, please <a href='%{url}'>contact our support</a>.",
  },
];
